import { RefBool, RefString } from "@tblabs/truffle";
import { FieldType } from "./FieldType";
import { RawField } from "./RawField";


export abstract class Field
{
    public abstract Type: FieldType;
    public Visible = new RefBool(true);
    public Tab = new RefString();
    public Icon = new RefString();
    public Header = new RefString();
    public Style = new RefString();
    public VisibleHeader = new RefBool(true);

    constructor(raw: Partial<RawField>)
    {
        this.Visible.value = raw.Visible ?? true;
        this.Tab.value = raw.Tab || "default";
        this.Icon.value = raw.Icon || "";
        this.Header.value = raw.Header || "";
        this.VisibleHeader.value = raw.VisibleHeader ?? true;
        this.Style.value = raw.Style || "";
    }
}
